<script lang="ts">
  import clsx from 'clsx';
  import { Link } from '@athena-lib/Link';
  import ArrowBack from '@athena-lib/Icons/ArrowBack.svelte';
  import ArrowForward from '@athena-lib/Icons/ArrowForward.svelte';
  import { cleanUrl, getPageNumbers } from './utils';
  import type { PaginationProps } from './types';
  const {
    class: className,
    pageCount,
    current,
    baseUrl,
    queryParamName = 'p',
  }: PaginationProps = $props();

  const cleanedBaseUrl = $derived(cleanUrl(baseUrl, queryParamName));
  const pageNumbers = $derived(getPageNumbers(pageCount, current));

  const listItemClass = clsx(
    'first:rounded-tl',
    'first:rounded-bl',
    'last:rounded-tr',
    'last:rounded-br',
    'text-center',
  );

  const listItemContentClass = clsx('px-3', 'py-1', 'block');

  function getItemClass(type: 'link' | 'arrow' | 'dots' | 'current') {
    if (type === 'current') {
      return clsx(listItemClass, 'font-bold text-st-black', 'bg-st-white');
    } else if (type === 'link') {
      return clsx(listItemClass, 'text-st-gray-600', 'bg-st-white');
    } else if (type === 'dots') {
      return clsx(listItemClass, 'text-st-gray-600', 'bg-st-white');
    } else if (type === 'arrow') {
      return clsx(
        'flex h-8 w-8 items-center justify-center rounded-full bg-st-black text-center text-st-white',
      );
    }
  }

  function getUrl(page: number) {
    return (
      cleanedBaseUrl + (!cleanedBaseUrl.includes('?') ? '?' : '&') + queryParamName + '=' + page
    );
  }
</script>

<nav aria-label="pagination">
  <ul class={clsx(className, 'flex items-center justify-center')}>
    {#if current !== 1}
      <li class={getItemClass('arrow')}>
        <Link class={clsx(listItemContentClass, 'pl-1 pr-1')} href={getUrl(current - 1)}>
          <ArrowBack sizeClass="h-5 w-5" />
        </Link>
      </li>
    {/if}
    {#each pageNumbers as page, idx}
      {#if idx !== 0 && pageNumbers[idx - 1] !== page - 1}
        <li class={getItemClass('dots')}>
          <span class={clsx(listItemContentClass, 'pl-1', 'pr-1')}>..</span>
        </li>
      {/if}
      <li class={getItemClass(page === current ? 'current' : 'link')}>
        {#if page === current}
          <Link
            class={clsx(listItemContentClass, 'cursor-auto')}
            href={getUrl(page)}
            aria-current="page"
          >
            {page}
          </Link>
        {:else}
          <Link class={listItemContentClass} href={getUrl(page)}>{page}</Link>
        {/if}
      </li>
    {/each}
    {#if current !== pageCount}
      <li class={getItemClass('arrow')}>
        <Link class={clsx(listItemContentClass, 'pl-1 pr-1')} href={getUrl(current + 1)}>
          <ArrowForward sizeClass="h-5 w-5" />
        </Link>
      </li>
    {/if}
  </ul>
</nav>
